"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmptyLpConfiguration = void 0;
const emptyTextNode = {
    delta: { ops: [] }
};
const getEmptyLpConfiguration = () => {
    return {
        version: 6,
        getSessionEndpointPrefix: "",
        background: {
            color: ""
        },
        loader: {
            logo: {
                url: "",
                platformId: ""
            },
            color: ""
        },
        header: {
            logo: {
                url: "",
                platformId: ""
            }
        },
        main: {
            headline: emptyTextNode,
            subheadline: emptyTextNode,
            playerConfiguration: {
                posterImage: {
                    url: "",
                    platformId: ""
                },
                analyticsToken: "",
                showLogo: true,
                playButtonColor: "",
                addTranscriptButton: false,
                lockPlayerBar: false,
                ccOnByDefault: false,
                largeCenterPlayIcon: false,
                rectangleCenterPlayIcon: false,
                logoOverlay: {
                    url: "",
                    platformId: "",
                    displayLogo: false
                },
                aspectRatio: "horizontal"
            },
            surveyConfiguration: {
                surveyId: null,
                backgroundColor: null,
                showAt: 0
            },
            buttons: []
        },
        footer: {
            disclaimer: emptyTextNode,
            showWatermark: true,
            privacyPolicy: {
                isVisible: false,
                url: "",
                text: "privacy policy",
                color: "#B2B2B2",
                font: ""
            }
        },
        fonts: {}
    };
};
exports.getEmptyLpConfiguration = getEmptyLpConfiguration;
//# sourceMappingURL=emptyConfiguration.js.map